export default "__VITE_ASSET__B2DnMaX8__"